(ns frontend.view.modals.pipeline-edit.events
  (:require [common.util :as cu]
            [frontend.actions.entity :as entity-actions]
            [frontend.state.current-session :as session]
            [frontend.view.modals.components.processing-modal :as processing-modal]))

(defn form-ready? [state*]
  (let [state @state*]
    (js/console.log "Pipeline edit ready ? " state " << " (cu/blank-value? (:pipeline/target-asset-types state)))
    (and (not (cu/blank-value? (:pipeline/name state)))
         (or (not= :entity.type/oppo (:pipeline/entity-type state))
             (not (cu/blank-value? (:pipeline/target-asset-types state)))))))

(defn no-changes?
  [state*]
  (let [state @state*
        entity (session/get-entity (:db/id state))]
    (->> [:db/id :pipeline/teams :pipeline/name :pipeline/target-asset-types :pipeline/fund
          :pipeline/valid-funds :pipeline/allow-without-target? :pipeline/inactive?]
         (remove (fn [attr]
                   (= (get entity attr)
                      (get state attr))))
         (empty?))))

(defn toggle-set [s val]
  (set (if (contains? s val)
         (disj s val)
         (conj s val))))

(defn modify-modules! [state kw val]
  (swap! state update kw toggle-set val))

(defn save! [state]
  (processing-modal/start-processing! state)
  (-> (entity-actions/*->entity-update! (:db/id @state)
                                        (cu/remove-nil-vals
                                         (select-keys @state
                                                      [:pipeline/teams
                                                       :pipeline/name
                                                       :pipeline/target-asset-types
                                                       :pipeline/fund
                                                       :pipeline/valid-funds
                                                       :pipeline/allow-without-target?
                                                       :pipeline/inactive?]))
                                        (partial processing-modal/success! state)
                                        (partial processing-modal/error! state))))
